import {MessageDescriptor} from '@ui/i18n/message-descriptor';

// An error whose (translatable) message is meant for the user as-is;
// showHttpErrorToast displays it instead of the generic fallback.
export class UserFacingError extends Error {
  constructor(public descriptor: MessageDescriptor) {
    super(descriptor.message);
  }
}
